import { AvailableLanguage } from "../constants/enums";
import Strings from "../constants/strings";
import Helpers from "./helpers";

import { object, string } from "yup";

export const multiLangSchema = (languages: AvailableLanguage[]) =>
    object({
        code: string().nullable(),
        value: object().test(
            "existed one value of multi content",
            Strings.Validation.REQUIRED,
            (value, context) => !languages.every((lang) => {
                return Helpers.isNullOrEmpty(value?.[lang])
            })
        ),
        searchText: string().nullable(),
    });
